import React from "react"
export default function Totalheader() {
  return <th class="border-bottom-0 text-center">Total(INR)</th>
}


// WEBPACK FOOTER //
// ./src/components/Costing/TotalHeader/index.js